export default __webpack_public_path__ + "locales/ro/Translations.json?hash=0b5225d5b52d3fb84d3be4ec8373b3f4";